import React from "react";
import ChristmasTheme, { isChristmasMonth } from "./holidays/ChristmasTheme";
import BerMonthsTheme, { isBerMonth } from "./holidays/BerMonthsTheme";
import SoulsMonthTheme, { isSoulsMonth } from "./holidays/SoulsMonthTheme";
import NewYearTheme, { isNewYear } from "./holidays/NewYearTheme";

const HOLIDAYS = [
  {
    name: "christmas",
    className: "christmas-theme",
    isActive: isChristmasMonth,
    Component: ChristmasTheme,
  },
  {
    name: "ber-months",
    className: "ber-months-theme",
    isActive: isBerMonth,
    Component: BerMonthsTheme,
  },
  {
    name: "souls-month",
    className: "souls-month-theme",
    isActive: isSoulsMonth,
    Component: SoulsMonthTheme,
  },
  {
    name: "new-year",
    className: "new-year-theme",
    isActive: isNewYear,
    Component: NewYearTheme,
  },
];

const getActiveHolidays = () => HOLIDAYS.filter((h) => h.isActive());

export const isHolidaySeason = () => getActiveHolidays().length > 0;

export const getHolidayClassName = () =>
  getActiveHolidays()
    .map((h) => h.className)
    .join(" ");

const HolidayTheme = ({ children, className = "" }) => {
  const activeHolidays = getActiveHolidays();

  if (activeHolidays.length === 0) return children || null;

  return activeHolidays.reduce(
    (wrapped, holiday) => (
      <holiday.Component className={className}>{wrapped}</holiday.Component>
    ),
    children,
  );
};

export default HolidayTheme;
